import { useCallback, useMemo } from "react";
import { recFigures, swapFigures, swapForRecommendation, } from "./recommendations";
import { buildSquadView, swapSquad, } from "./squad";
/** A squad as the pitch draws it; see buildSquadView. */
export const useSquadView = (source, maths) => useMemo(() => (source ? buildSquadView(source, maths) : undefined), [source, maths]);
/** Works out swaps on a squad; see swapSquad. */
export const useSquadSwap = (source, before, maths) => useCallback((swap) => source && before ? swapSquad(source, before, swap, maths) : undefined, [source, before, maths]);
/**
 * Each recommendation swapped into the active squad, worked out with the
 * squad builder's maths: what it does for the player, and also for the
 * players around it, whose chemistry it can raise or cost. Without a slot
 * for it, a recommendation keeps its own figures.
 */
export const useRecommendationSwaps = (recommendations, squad, swap, toPitchPlayer) => {
    const swaps = useMemo(() => {
        const byRec = new Map();
        for (const rec of recommendations) {
            const recSwap = swapForRecommendation(rec, squad, toPitchPlayer);
            if (recSwap)
                byRec.set(rec.id, recSwap);
        }
        return byRec;
        // Callers pass a module function for toPitchPlayer, so it never changes.
    }, [recommendations, squad, toPitchPlayer]);
    const figures = useMemo(() => {
        const byRec = new Map();
        for (const rec of recommendations) {
            const recSwap = swaps.get(rec.id);
            const swapped = recSwap && swap(recSwap);
            byRec.set(rec.id, (swapped && swapFigures(swapped)) ?? recFigures(rec));
        }
        return byRec;
    }, [recommendations, swaps, swap]);
    const figuresOf = useCallback((rec) => figures.get(rec.id) ?? recFigures(rec), [figures]);
    return { swaps, figuresOf };
};
//# sourceMappingURL=hooks.js.map